/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_Cancel_QInputs */

const en_price_page_faq_cancel_q = /** @type {(inputs: Price_Page_Faq_Cancel_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if I cannot make it?`)
};

const pl_price_page_faq_cancel_q = /** @type {(inputs: Price_Page_Faq_Cancel_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co, jeśli nie mogę przyjść?`)
};

/**
* | output |
* | --- |
* | "What if I cannot make it?" |
*
* @param {Price_Page_Faq_Cancel_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_cancel_q = /** @type {((inputs?: Price_Page_Faq_Cancel_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_Cancel_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_cancel_q(inputs)
	return en_price_page_faq_cancel_q(inputs)
});